export default __webpack_public_path__ + "static/media/clessidra-in-corso.7880ec4e.png";